import './Footer.css';

function Footer () {
    return (
        <footer className='footer'>
          <p className='footer__info'>ИП Кайко О.В</p>
        </footer>
    )
}

export default Footer;